(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["MAINHEADER"]) return;
  try {
    


  class StickyHeader extends HTMLElement {


    constructor() {
      super();
    }




    connectedCallback() {


      this.header =
        this;


      this.headerIsAlwaysSticky =
        this.getAttribute(
          'data-sticky-type'
        ) === 'always';


      this.currentScrollTop =
        window.pageYOffset || 0;


      this.onScrollHandler =
        this.onScroll.bind(this);


      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        {
          passive: true
        }
      );


    }




    disconnectedCallback() {


      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );


    }




    onScroll() {


      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;




      if (
        this.headerIsAlwaysSticky
      ) {


        this.style.position =
          'sticky';


        this.style.top =
          '0';


        this.style.width =
          '100%';


        this.currentScrollTop =
          scrollTop;


        return;


      }




      if (
        scrollTop <
        this.currentScrollTop &&
        scrollTop > 150
      ) {


        this.style.position =
          'sticky';


        this.style.top =
          '0';


        this.style.width =
          '100%';


      }


      else if (
        scrollTop <= 150
      ) {


        this.style.position =
          'relative';


        this.style.top =
          'auto';


        this.style.width =
          '100%';


      }




      this.currentScrollTop =
        scrollTop;


    }


  }




  if (
    !customElements.get(
      'sticky-header'
    )
  ) {


    customElements.define(
      'sticky-header',
      StickyHeader
    );


  }



  } catch(e) { console.error(e); }
})();
})();
